var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{staticClass:"form-control",on:{"input":_vm.changed}},_vm._l((this.column.options),function(key,value){return _c('option',{key:key,domProps:{"value":value}},[_vm._v(_vm._s(key))])}))}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6eeef26e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/metronic/table/header/ColumnSelect.vue
// module id = +7fp
// module chunks = 0 1 2